import { connect } from 'react-redux'

import { makeUpdateFilter } from 'actions/ui/shared/filter'
import { CobaltPath } from 'routing/Path'
import { selectDomainValue as selectAuthDomainValue } from 'selectors/auth'
import { selectOrganizationMembers } from 'selectors/orgs'
import { selectDashboardOfPage, selectDomainValue } from 'selectors/ui'
import { RootReduxState } from 'types'

import ShareButton from './ShareButton'

const PAGE_PATH: CobaltPath = ['dashboardPage']

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapStateToProps = (state: RootReduxState) => ({
    dashboard: selectDashboardOfPage(state, PAGE_PATH[0]),
    orgMembers: selectOrganizationMembers(
        state,
        selectAuthDomainValue(state, ['organizationId'])
    ),
    userEmail: selectAuthDomainValue(state, ['email']),
    isDirty: selectDomainValue(state, [PAGE_PATH[0], 'isDirty']),
})

const mapDispatchToProps = {
    updateFilter: makeUpdateFilter(PAGE_PATH),
}

export default connect(mapStateToProps, mapDispatchToProps)(ShareButton)
